const mediaItems = [
  {
    title: '深度解析：某顶流明星塌房事件时间线全梳理',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20visual%20with%20warm%20red%20and%20dark%20amber%20gradient%2C%20geometric%20timeline%20elements%20overlay%2C%20dramatic%20lighting%20with%20atmospheric%20depth%2C%20modern%20editorial%20documentary%20style%20composition&width=800&height=450&seq=media-01-2026&orientation=landscape',
    duration: '12:36',
    tag: '深度报道',
    views: 258000,
  },
  {
    title: '独家揭秘：某知名网红背后的资本运作黑幕',
    image: 'https://readdy.ai/api/search-image?query=Investigative%20abstract%20visual%20with%20dark%20red%20and%20gold%20geometric%20patterns%2C%20layered%20shapes%20representing%20hidden%20connections%2C%20dramatic%20shadow%20play%2C%20modern%20editorial%20style%20with%20mysterious%20atmosphere&width=800&height=450&seq=media-02-2026&orientation=landscape',
    duration: '18:42',
    tag: '独家揭秘',
    views: 412000,
  },
  {
    title: '爆料现场：某综艺录制后台冲突全程实录分析',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20scene%20with%20warm%20crimson%20and%20amber%20lighting%2C%20geometric%20shapes%20representing%20conflict%20and%20tension%2C%20editorial%20documentary%20aesthetic%2C%20bold%20composition%20with%20strong%20visual%20narrative&width=800&height=450&seq=media-03-2026&orientation=landscape',
    duration: '08:15',
    tag: '现场还原',
    views: 189000,
  },
  {
    title: '数据说话：2025年度吃瓜黑料事件大盘点',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20red%20and%20dark%20orange%20gradients%2C%20geometric%20chart%20elements%20and%20layered%20shapes%2C%20modern%20infographic%20style%2C%20clean%20editorial%20design%20with%20dramatic%20contrast&width=800&height=450&seq=media-04-2026&orientation=landscape',
    duration: '22:08',
    tag: '年度盘点',
    views: 536000,
  },
  {
    title: '当事人讲述：被网暴三年的素人如何维权',
    image: 'https://readdy.ai/api/search-image?query=Intimate%20abstract%20portrait%20visual%20with%20warm%20soft%20red%20and%20cream%20tones%2C%20geometric%20shapes%20representing%20personal%20story%2C%20documentary%20editorial%20style%2C%20emotional%20depth%20with%20atmospheric%20lighting%20and%20texture&width=800&height=450&seq=media-05-2026&orientation=landscape',
    duration: '15:20',
    tag: '人物专访',
    views: 327000,
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full">视频爆料</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选视频</h2>
          <p className="mt-2 text-sm text-foreground-500">深度解读热点爆料事件</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, index) => (
            <article key={index} className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200 transition-colors cursor-pointer group">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 text-xs px-2 py-1 bg-black/70 text-background-50 rounded-md whitespace-nowrap">{item.duration}</span>
                <span className="absolute top-3 left-3 text-xs px-2 py-1 bg-accent-500/90 text-background-50 rounded-md whitespace-nowrap">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 leading-relaxed group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
                <div className="mt-2 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i> {(item.views / 1000).toFixed(0)}k 次观看
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}